import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";

// const getToken = () => localStorage.getItem("Myleads");

// // API headers including token
// const getAuthHeaders = () => ({
//   headers: {
//     Authorization: `Bearer ${getToken()}`,
//   },
// });
export const getAllInvoice = createAsyncThunk(
  "invoice/getAllInvoice",
  async () => {
    try {
      const response = await BaseUrl.get("/quotation");
      // console.log("response.data===>", response.data);
      return response.data.data;
    } catch (error) {
      alert(`${error.response.data.message}`);
      throw error;
    }
  }
);
export const getClientDropdata = createAsyncThunk(
  "client/getClientDropdata",
  async () => {
    try {
      const response = await BaseUrl.get(`customers/customerDroupDown`);
      // console.log("response.data", response.data);
      return response.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
export const getCustomerSingledata = createAsyncThunk(
  "client/getCustomerSingledata",
  async (id) => {
    // console.log("id====>", id);
    try {
      const response = await BaseUrl.get(`customers/${id}`);

      // console.log("response.data", response.data.data);
      return response.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
export const AddSingleItemdata = createAsyncThunk(
  "invoice/AddSingleItemdata",
  async (data) => {
    try {
      const response = await BaseUrl.post(`invoice-item`, data);

      // console.log("response.data", response.data.data);
      return response.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
export const GetAllItemdata = createAsyncThunk(
  "invoice/GetAllItemdata",
  async () => {
    try {
      const response = await BaseUrl.get(`item-setup`);

      // console.log("response.data", response.data.data);
      return response.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
export const GetItemDropdata = createAsyncThunk(
  "item/GetItemDropdata",
  async () => {
    try {
      const response = await BaseUrl.get(`/item-setup/itemsDropDown`);
      // console.log("response.data", response.data.data);
      return response.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
export const getItemSingledata = createAsyncThunk(
  "item/getItemSingledata",
  async (id) => {
    // console.log("id====>", id);
    try {
      const response = await BaseUrl.get(`item-setup/${id}`);

      // console.log("response.data", response.data.data);
      return response.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
export const createQuotationInvoicedata = createAsyncThunk(
  "invoice/createQuotationInvoicedata",
  async (data) => {
    try {
      const response = await BaseUrl.post(`quotation/`, data);
      // console.log("response.data", response.data.data);
      return response.data.data;
    } catch (error) {
      console.log("error.response.data", error.response.data);

      return error.response.data;
    }
  }
);

export const quatationInvoiceDown = createAsyncThunk(
  "invoice/quatationInvoiceDown",
  async (data) => {
    try {
      const response = await BaseUrl.post(`generate-pdf/quotation`, { quotationNo: data });
      // console.log("response.data", response.data.data);
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);

export const getSingleQuotationdata = createAsyncThunk(
  "invoice/getSingleQuotationdata",
  async (id) => {
    console.log("id===>", id);
    try {
      const response = await BaseUrl.get(`quotation/${id}`);
      console.log("response.data===============>", response.data.data);
      return response.data.data;
    } catch (error) {
      // console.log("error.response.data", error.response.data);
      return error.response.data;
    }
  }
);
export const updateQuotationInvoincedata = createAsyncThunk(
  "invoice/updateQuotationInvoincedata",
  async (data) => {
    try {
      const response = await BaseUrl.patch(`quotation/`, data);
      console.log("response.data", response.data.data);
      return response.data.data;
    } catch (error) {
      // console.log("error.response.data", error.response.data);

      return error.response.data;
    }
  }
);
export const deleteInvoiceItemdata = createAsyncThunk(
  "invoice/deleteInvoiceItemdata",
  async (id) => {
    try {
      const response = await BaseUrl.delete(`invoice-item/${id}`);
      console.log("response.data", response.data);
      return response.data;
    } catch (error) {
      // console.log("error.response.data", error.response.data);

      return error.response.data;
    }
  }
);
export const quotationSlice = createSlice({
  name: "quotation",
  initialState: {
    quotationData: [],
    clientDropData: [],
    singleData: {},
    allitemdata: [],
    itemdropData: [],
    singleItemData: {},
    singleInvoiceData: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllInvoice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.quotationData = action.payload;
      })
      .addCase(getAllInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(getClientDropdata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClientDropdata.fulfilled, (state, action) => {
        state.loading = false;
        state.clientDropData = action.payload;
      })
      .addCase(getClientDropdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(getCustomerSingledata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomerSingledata.fulfilled, (state, action) => {
        state.loading = false;
        state.singleData = action.payload;
      })
      .addCase(getCustomerSingledata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(GetAllItemdata.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllItemdata.fulfilled, (state, action) => {
        state.loading = false;
        state.allitemdata = action.payload;
      })
      .addCase(GetAllItemdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(GetItemDropdata.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetItemDropdata.fulfilled, (state, action) => {
        state.loading = false;
        state.itemdropData = action.payload;
      })
      .addCase(GetItemDropdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(getItemSingledata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getItemSingledata.fulfilled, (state, action) => {
        state.loading = false;
        state.singleItemData = action.payload;
      })
      .addCase(getItemSingledata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(getSingleQuotationdata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSingleQuotationdata.fulfilled, (state, action) => {
        state.loading = false;
        state.singleInvoiceData = action.payload;
      })
      .addCase(getSingleQuotationdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const getAllInvoiceData = (state) => state.quotation.quotationData;
export const getAllClientDropData = (state) => state.quotation.clientDropData;
export const getSingleCustomerData = (state) => state.quotation.singleData;
export const getAllItemData = (state) => state.quotation.allitemdata;
export const getAllItemDropData = (state) => state.quotation.itemdropData;
export const getSingleItemData = (state) => state.quotation.singleItemData;
export const getQuotationUniqueData = (state) =>
  state.quotation.singleInvoiceData;
// export const loader = (state) => state.invoice.loading;
export default quotationSlice.reducer;
